export const APPLICATION_INFO_PANEL_INITIAL_STATE = {
  hasVisibility: false,
  heading: '',
  description: '',
  additionalInformation: '',
};

export default APPLICATION_INFO_PANEL_INITIAL_STATE;
